import { Component, input } from '@angular/core';
import { BarInputs } from '@charts';
import { BarChartComponent } from "../bar-chart";

@Component({
  selector: 'ui-rsabt-voltage-chart',
  imports: [BarChartComponent],
  template: `
    <ui-bar-chart class="max-h-96" [barInputs]="barInputs()" />
  `
})

export class RsabtVoltageChartComponent {
  barInputs = input.required<BarInputs>();
}
